export const courses = [
  {
    label: "Class 9Th science",
    description: `Lets explore real world of science which begins here. Science is all about
    knowledge gained from observation & experiment when organized properly. We
    here will develop “habits” to change our view for science, we will make it subject
    of interest. Science is everything you observe ,only difference is that one who
    knows how to analyse it properly, finds interesting while one who just find it as
    subject will not find anything interesting. Lets explore it together.`,
    image: "assets/img/subject/9s.jpg",
    price: "899"
  },
  {
    label: "Class 9th maths",
    description: `Lets play with numbers now. Have you ever tried to find how significant relations can exist
    between numbers? , Why series are so important?
    Mathematics is such a beautiful tool to express anything in equation forms. One who
    commands maths will command physics( maths being most important tool). Every activities in
    life relates to some equations with some boundary conditions. Now problem is to find proper
    equation which can solve other problems. Lets find equations which can an alternative solution
    to other problems. Lets explore different mathematical aspects of life which lays foundation for
    higher classes.`,
    image: "assets/img/subject/9math.jpg",
    price: "899"
  },
  {
    label: "Class 9th HTML",
    description: `Lets explore world of Web Development. Have you wondered how any websites are made? , How you
    interact with website & how these design affects websites. Here we are going to understand basic terms
    of web development, how to organize any webpage & what are basic rules to start with Web pages. We
    will explore what HTML can really do with Web pages, websites or blogs. Lets explore together.`,
    image: "assets/img/subject/9html.jpg",
    price: "899"
  },
  {
    label: "Class 10th science",
    description: `Lets explore real world of science which begins here. Science is all about
    knowledge gained from observation & experiment when organized properly. We
    here will develop “habits” to change our view for science, we will make it subject
    of interest. Science is everything you observe ,only difference is that one who
    knows how to analyse it properly, finds interesting while one who just find it as
    subject will not find anything interesting. Lets explore it together.`,
    image: "assets/img/subject/10s.jpg",
    price: "899"
  },
  {
    label: "Class 10th maths",
    description: `Lets play with numbers now. Have you ever tried to find how significant relations can exist
    between numbers? , Why series are so important?
    Mathematics is such a beautiful tool to express anything in equation forms. One who
    commands maths will command physics( maths being most important tool). Every activities in
    life relates to some equations with some boundary conditions. Now problem is to find proper
    equation which can solve other problems. Lets find equations which can an alternative solution
    to other problems. Lets explore different mathematical aspects of life which lays foundation for
    higher classes.`,
    image: "assets/img/subject/10math.jpg",
    price: "899"
  },
  {
    label: "Class 10th HTML",
    description: `Lets explore world of Web Development. Have you wondered how any websites are made? , How you
    interact with website & how these design affects websites. Here we are going to understand basic terms
    of web development, how to organize any webpage & what are basic rules to start with Web pages. We
    will explore what HTML can really do with Web pages, websites or blogs. Lets explore together.`,
    image: "assets/img/subject/10html.jpg",
    price: "899"
  },
  {
    label: "Class 11th chemistry",
    description: `“Those who are not shocked when they first come across quantum theory cannot possibly have
    understood it”- Neil Bohr
    Chemistry starts as separate stream of science here. “Quantum mechanics” is beauty which
    explains diverse phenomenon that exists in our surroundings. Here you will explore behaviour
    of known surrounding which you never thought it as it can be. Lets explore how molecule forms
    , how energy is conserved, what Dalton observed first time, what were significant evolution in
    chemistry filed. All the best.`,
    image: "assets/img/subject/11c.jpg",
    price: "999"
  },
  {
    label: "Class 11th physics",
    description: `“ I think nature’s imagination is so much greater than man’s, she’s never going to let us relax”-
    Richard Feynman.
    Have you wondered why water droplets takes spherical shapes?
    Why surface tension comes into role?
    Significance of Newton’s law of motion?
    Question being developed are endless but what’s beauty, “99% questions have satisfactory
    answers that proves beauty of our nature.” Physics is considered to be nature’s language. Lets
    find out why.
    “Love isn’t most important thing, Physics is”`,
    image: "assets/img/subject/11p.jpg",
    price: "999"
  },
  {
    label: "Class 11th maths",
    description: `“However difficult life may seem, there is always something you can do & succeed at”- Stephen
    Hawking
    MATHS lays foundation for sets, relations & functions, trigonometric functions, complex
    number & many more “base” areas . Lets explore different ways of arrangement(P n C’s) ,
    complex equation & many exciting topics. Lets go.`,
    image: "assets/img/subject/11math.jpg",
    price: "999"
  },
  {
    label: "Class 12th chemistry",
    description: `“ The nitrogen in our DNA, the calcium in our Teeth, the Iron in our blood, the Carbon in our
    Apple pies were made in the interiors of collapsing Stars. We are made of Star Stuff” – Carl
    Sagan
    Finally at intermediate level of education. Here chemistry lays foundation for various fields like
    how reaction works, rate of reaction, importance of organic chemistry & many more exciting
    stuff. Lets enter in world full of reactions, lets explore its beauty.`,
    image: "assets/img/subject/12c.jpg",
    price: "",
    date: "Will be active from March 2021"
  },
  {
    label: "Class 12th physics",
    description: `“ It is reasonable to ask who or what created the universe, but if the answer is God, then the
    question has been merely deflected to that of who created god”- Stephen Hawking.
    Physics has always been fascinating for researchers from centuries. Discovery of current lead to
    very remarkable act in history. Class 12th foundation are based on electricity , magnetism ,
    induction, optics & modern physics. Here you will discover about evolution of physics & its
    fascinating areas. Lets explore it together. Lets play with physics.`,
    image: "assets/img/subject/12p.jpg",
    price: "",
    date: "Will be active from March 2021"
  },
  {
    label: "Class 12th maths",
    description: `“ One could perhaps describe the situation by saying that God is a mathematician of a very high
    order & he used very advanced mathematics in constructing the universe”- Paul Dirac
    
    This subject is really fun connecting mathematics deeply with physics. Lets explore significance
    of matrix, determinants, differential equation, probability & more. Many find probability as
    boring while some as interesting. This is due to difference in understanding. If you start work,
    you know its probability of success/ failure. You plan accordingly. Lets explore “chances of
    winning”.`,
    image: "assets/img/subject/12math.jpg",
    price: "",
    date: "Will be active from March 2021"
  },
  {
    label: "Package A (9th)",
    description: `This package give access to Maths and Science`,
    image: "assets/img/subject/9thA.jpg",
    price: "1699",
    package: " Maths + Science"
  },
  {
    label: "Package B (9th)",
    description: `This package give access to Maths, Science and HTML`,
    image: "assets/img/subject/9thB.jpg",
    price: "1999",
    package: "Maths + Science + HTML"
  },
  {
    label: "Package A (10th)",
    description: `This package give access to Maths and Science`,
    image: "assets/img/subject/10thA.jpg",
    price: "1699",
    package: "Maths + Science"
  },
  {
    label: "Package B (10th)",
    description: `This package give access to Maths, Science and HTML`,
    image: "assets/img/subject/10thB.jpg",
    price: "1999",
    package: "Maths + Science + HTML"
  },
  {
    label: "Package A(11th)",
    description: `This package give access to Physics, Chemistry and Maths`,
    image: "assets/img/subject/11thA.jpg",
    price: "2699",
    package: "Physics + Chemistry + Maths"
  },
];